import React, { useEffect } from "react";
import * as echarts from "echarts";

interface DepartmentData {
  name: string;
  value: number;
  color: string;
}

interface ChartItem {
  month: string;
  departments: DepartmentData[];
}

interface BarChartProps {
  chartData: ChartItem[];
}

const TeamEngagementBar = ({ chartData }: any) => {
  useEffect(() => {
    const data = chartData || [];

    // Create a bar chart
    const chartElement = document.getElementById(
      "bar-chart"
    ) as HTMLDivElement;
    const chart = echarts.init(chartElement);

    // Extract department names dynamically

    // const options = {
    //   xAxis: {
    //     type: "category",
    //     data: data.map((item: ChartItem) => item.month),
    //     axisLabel: {
    //       rotate: 45,
    //     },
    //   },
    //   yAxis: {
    //     type: "value",
    //     min: 1,
    //     max: 8, // Set the maximum value of the y-axis as needed
    //     interval: 1,
    //   },
    //   series: departmentNames.map((department: any) => ({
    //     name: department,
    //     type: "bar",
    //     data: data.map((item: ChartItem) => {
    //       const depData = item.departments.find(
    //         (dep) => dep.name === department
    //       );
    //       return depData ? depData.value : 0;
    //     }),
    //     itemStyle: {
    //       color: (item: any) => {
    //         const depData = data
    //           .find((d: any) => d.month === item.name)
    //           ?.departments.find((dep: any) => dep.name === department);
    //         return depData ? depData.color : "#000000"; // Default color if no color is found
    //       },
    //     },
    //   })),
    // };

    const seriesData = data?.months?.map(
      (_: any, index: any) => data?.data[index] || 0
    );

    function getBarWidth(minWidth: number): number | string {
      const categoriesCount = data?.months?.length || 0;
      return categoriesCount <= 3 ? minWidth : "auto";
    }

    const options = {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
      },
      grid: {
        left: "0%",
        right: "5%",
        bottom: "6%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        axisTick: { show: false },
        data: data?.months,
      },
      yAxis: {
        type: "value",
        min: 0, // Set minimum value
        max: 8, // Set maximum value
        // interval: 50,
        //type: "value",
      },
      series: [
        {
          data: seriesData,
          type: "bar",
          barWidth: getBarWidth(6),
          itemStyle: { color: data.color, barBorderRadius: [5, 5, 0, 0] },
        },
      ],
    };

    // Set chart options
    chart.setOption(options);

    const resizeObserver = new ResizeObserver(() => {
      chart.resize();
    });
    if (chartElement) resizeObserver.observe(chartElement);

    // Cleanup on unmount
    return () => {
      resizeObserver.disconnect();
      chart.dispose();
    };
  }, [chartData]);

  return (
    <div
      id="bar-chart"
      style={{
        width: "100%",
        height: "257px",
        margin: "0 !important",
        cursor: "not-allowed !important",
      }}
    ></div>
  );
};

export default TeamEngagementBar;
